import './ytCardStatus.scss'
import nodataImg from '@/assets/images/nodata.png'
import searchErrorImg from '@/assets/images/seach-error.png'
import networkErrorImg from '@/assets/images/net-error.png'
import systemErrorImg from '@/assets/images/xitong-error.png'

const messageText = ['暂无数据', '搜索不到内容...', '网络异常', '404', '系统错误']
const messageImage = [nodataImg, searchErrorImg, networkErrorImg, systemErrorImg]

export default {
    name: 'YtCardStatus',

    props: {
        // 显示状态, 1: 无数据, 2: 搜索为空, 3: 网络异常, 4: 404, 5: 系统错误
        type: {
            type: Number,
            default: 1
        },

        // 是否显示提示文字
        showMessage: {
            type: Boolean,
            default: true
        },

        // 提示文字
        message: {
            type: String,
            default: ''
        },

        width: {
            type: Number,
            default: 300
        },

        height: {
            type: Number,
            default: 260
        }
    },

    computed: {
        localMessage() {
            if (this.message) {
                return this.message
            } else {
                return messageText[this.type - 1]
            }
        },

        localImage() {
            return messageImage[this.type - 1]
        }
    },

    render() {
        return (
            <div class='ytCardStatus'>
                <el-image class='img' style={`width: ${this.width}px; height: ${this.height}px;`} fit='contain' src={this.localImage} />
                {/* <div class='message'>{this.localMessage}</div> */}
                {
                    (this.showMessage && !this.$slots.message) && <div class='message' domPropsInnerHTML={this.localMessage} />
                }

                {
                    (this.showMessage && this.$slots.message) && this.$slots.message
                }
            </div>
        )
    }
}
